import { BaseContainerModel } from '../base-container.model';
import { bl_hc_patient_appointment_hdr_RowClass, bl_hc_patient_appointment_hdr_RowInterface } from '../../dbschema/bl_hc_patient_appointment_hdr.model';


export class HcPatientAppointmentHdrContainerModel extends BaseContainerModel {
  bl_hc_patient_appointment_hdr: bl_hc_patient_appointment_hdr_RowInterface = new bl_hc_patient_appointment_hdr_RowClass();
}